import { Tab, Tabs, tabsClasses } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { useNavigationTabs } from '../../../hooks';
import ChipNew from './ChipNew';

export default function NavigationTabs() {
    const { t } = useTranslation('navigation');
    const navigate = useNavigate();
    const { tabs, activeTab } = useNavigationTabs();
    const location = useLocation();

    const handleTabChange = (tabId: string) => {
        const selectedTab = tabs.find(tab => tab.id === tabId);

        if (selectedTab && location.pathname !== selectedTab.path) {
            navigate(selectedTab.path);
        }
    };

    return (
        <StyledTabs
            value={ tabs.findIndex(tab => tab.id === activeTab) }
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            role="navigation"
            indicatorColor="secondary"
        >
            { tabs.map((tab) => (
                <StyledTab
                    key={ tab.path }
                    label={ t(`navigationItem.${ tab.id }`) }
                    id={ `nav-tab-${ tab.id }` }
                    aria-controls={ `nav-tabpanel-${ tab.id }` }
                    iconPosition="end"
                    onClick={ () => handleTabChange(tab.id) }
                    icon={ tab.isNew
                        ? <ChipNew active={ tab.id === activeTab } />
                        : undefined }
                />
            )) }
        </StyledTabs>
    );
}

const StyledTabs = styled(Tabs)(({ theme }) => ({
    minHeight: 48,
    borderTop: `1px solid ${ theme.palette.divider }`,
    
    [`& .${ tabsClasses.list }`]: {
        padding: theme.spacing(0, 6)
    }
}));

const StyledTab = styled(Tab)(({ theme }) => ({
    color: theme.palette.text.primary,

    '&:hover': {
        color: theme.palette.secondary.main
    }
}));
